/* The mockup's `.field` with `.sw-row` switches in a row and a `.help` line under them. */
.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-inline-size: 0;
}

.label {
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
}

/* Mockup v3 P5: one line per scope (`.sw-line`): the switch, then what the scope uses now. */
.lines {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin: 0;
  padding: 0;
  list-style: none;
}

.line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: var(--space-2);
}

.line > .error {
  flex-basis: 100%;
}

.meta {
  color: var(--text-muted);
  font-size: var(--font-size-12);
}

.hint,
.readOnly {
  margin: 0;
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

.readOnly {
  color: var(--text-muted);
  font-size: var(--font-size-13);
}

.error {
  margin: 0;
  color: var(--danger-text);
  font-size: var(--font-size-13);
}
